export const navLinks = [
  { label: 'Home', destination: '#' },
  { label: 'Products', destination: '#', type: 'dropdown' },
  { label: 'Investment Club', destination: '#' },
  { label: 'Blog', destination: '#' },
  { label: 'About Us', destination: '#' },
  { label: 'FAQs', destination: '#' },
];
